import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IPaymentMethodModel extends IModel {
  paymentMethodId: number;
  name: string;
}

export class PaymentMethodModel
  extends Model
  implements ModelRecord<IPaymentMethodModel>
{
  paymentMethodId: number;
  name: string;

  constructor(params?: Partial<IPaymentMethodModel>) {
    super(params);
    this.paymentMethodId = defaultTo(params?.paymentMethodId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
